import { render, staticRenderFns } from "./SubmitEPUAP.vue?vue&type=template&id=96029f16&"
import script from "./SubmitEPUAP.vue?vue&type=script&lang=js&"
export * from "./SubmitEPUAP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports